import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getTeam = (params) => {
    const { teamId, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/teams/${teamId}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_TEAM,
                payload: {
                    team: body
                }
            });
        });
};

export const getTeamActivityData = (params) => {
    const { teamId, limit = 5, page = 1, skip = 0, typeToRetrieve = 'activity', pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/teams/${teamId}/activitystream`;
    const url = buildQueryString({ limit, page, skip, type: typeToRetrieve }, baseUrl);
    return VerbFetch(url);
};

export const getTeamMemberProfiles = (params) => {
    const { teamId, limit, page, includeCompanyName = false, pathsContext } = params;
    const queryParams = { limit, page };
    if (includeCompanyName) queryParams.includeCompanyName = includeCompanyName;
    const baseUrl = `${pathsContext.serverUrl}/teams/${teamId}/profiles`;
    const url = buildQueryString(queryParams, baseUrl);
    return VerbFetch(url);
};

export const putTeam = (params) => {
    const { teamId, body, pathsContext } = params;
    const uri = `${pathsContext.serverUrl}/teams/${teamId}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_TEAM_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_TEAM_SUCCESS,
                    payload: {
                        team: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const putTeamAssignment = (params) => {
    const { teamId, body, pathsContext } = params;
    const uri = `${pathsContext.serverUrl}/teams/${teamId}/teamcollection`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_TEAM_ASSIGNMENT,
                    payload: {
                        team: response.team
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const getManyTeams = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/teams`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_TEAMS,
                    payload: {
                        teams: body
                    }
                });
                return body;
            })
            .catch(console.error);
};

export const postTeamAdmin = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/teams`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_TEAM_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_TEAM_SUCCESS,
                    payload: {
                        team: response
                    }
                });
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    };
};

export const getTeamAdmin = (params) => {
    const { teamId, pathsContext } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/teams/${teamId}`;
    delete params.teamId;
    delete params.pathsContext;

    const url = buildQueryString(params, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_TEAM_ADMIN,
                    payload: {
                        team: body
                    }
                });
                return body;
            })
            .catch(console.error);
};

export const getManyTeamsAdmin = (params, dispatchDisabled) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/teams`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                if (!dispatchDisabled) {
                    dispatch({
                        type: ACTIONS.GET_MANY_TEAMS,
                        payload: {
                            teams: body
                        }
                    });
                }
                return body;
            })
            .catch(console.error);
};

export const putTeamsLocal = (body) => (dispatch) => {
    dispatch({
        type: ACTIONS.PUT_TEAMS_LOCAL,
        payload: {
            teams: body
        }
    });
};

export const putTeamAdmin = (params) => {
    const { teamId, body, getAllMembers = false, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/teams/${teamId}${getAllMembers ? '?getAllMembers=true' : ''}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_TEAM_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_TEAM_SUCCESS,
                    payload: {
                        team: response
                    }
                });
                return response;
            })
            .catch((err) => {
                console.error(err);
                throw err;
            });
    };
};

/**
 *
 * @param {*} params
 */
export const deleteTeamFromList = (params) => {
    const { id } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.DELETE_TEAM_SUCCESS,
            payload: {
                id
            }
        });
    };
};

export const updateTeamMembers = (params) => {
    const { teamId, action, membersToUpdate, pathsContext } = params;
    let actions;
    if (action === 'add') {
        actions = [ACTIONS.ADD_TEAM_MEMBERS_START, ACTIONS.ADD_TEAM_MEMBERS_SUCCESS];
    } else {
        actions = [ACTIONS.REMOVE_TEAM_MEMBERS_START, ACTIONS.REMOVE_TEAM_MEMBERS_SUCCESS];
    }
    return (dispatch) => {
        dispatch({
            type: actions[0],
            payload: {
                body: membersToUpdate
            }
        });
        const url = `${pathsContext.adminServerUrl}/teams/${teamId}/members`;
        return VerbFetch(url, {
            method: 'PUT',
            body: {
                membersToUpdate,
                action
            }
        })
            .then((response) => {
                dispatch({
                    type: actions[1],
                    payload: {
                        teamId,
                        updatedUserProfiles: response
                    }
                });
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    };
};

export const setUnsavedChanges = (flag) => (dispatch) => {
    return dispatch({
        type: ACTIONS.SET_UNSAVED_CHANGES,
        payload: {
            teamsUnsavedFlag: flag
        }
    });
};
